const { connect } = require('react-redux');
const BrokerCustomWalletPreLeaveEditionModal =  require ('./brokerCustomWalletPreLeaveEditionModal');
// @ actions
const portfolios = require('../../actions/brokerCustomWalletPortfolios.js');

module.exports.BrokerCustomWalletPreLeaveEditionModal = connect(
    state => ({
        immBrokerCustomWalletPortfolios: state.brokerCustomWalletPortfolios
    }),
    {
        onConfirmLeaveEditionToOtherPage: portfolios.confirmLeaveEditionToOtherPage,
    }
)(BrokerCustomWalletPreLeaveEditionModal);
